import { OTLPMetricExporter } from '@opentelemetry/exporter-metrics-otlp-http';
import { Resource } from '@opentelemetry/resources';
import { MeterProvider, PeriodicExportingMetricReader } from '@opentelemetry/sdk-metrics';
import { CI_METRICS_OTEL_TOKEN, OTEL_COLLECTOR_URL, OTEL_SERVICE_NAME, SEMRESATTRS_SERVICE_NAME, } from './constants';
export let meter;
export let meterProvider;
export const forceFlush = () => meterProvider.forceFlush();
export const init = ({ exporterOptions, serviceName, otelUrl, otelToken, dryRun, customReaders, }) => {
    const authorization = otelToken || CI_METRICS_OTEL_TOKEN
        ? {
            Authorization: `Bearer ${otelToken || CI_METRICS_OTEL_TOKEN}`,
        }
        : {};
    const headers = {
        ...(exporterOptions?.headers || {}),
        ...authorization,
    };
    const exporter = new OTLPMetricExporter({
        url: `${otelUrl || OTEL_COLLECTOR_URL}/v1/metrics`,
        headers,
    });
    const readers = customReaders || [];
    if (!dryRun) {
        const reader = new PeriodicExportingMetricReader({
            ...exporterOptions,
            exporter,
        });
        readers.push(reader);
    }
    meterProvider = new MeterProvider({
        resource: new Resource({
            [SEMRESATTRS_SERVICE_NAME]: serviceName || OTEL_SERVICE_NAME,
        }),
        readers,
    });
    meter = meterProvider.getMeter(serviceName || OTEL_SERVICE_NAME);
};
export const destroy = () => {
    meter = undefined;
    return meterProvider.shutdown();
};
//# sourceMappingURL=metrics.js.map